import { Query } from '@apollo/client/react/components'
import LinearProgress from '@material-ui/core/LinearProgress'
import PropTypes from 'prop-types'
import Error from '@components/error'
import CtflAsset from './ctfl-asset'
import { assetQuery } from './ctfl-asset.query'

export default function CtflAssetWithData({ id, ...props }) {
  return (
    <Query query={assetQuery} variables={{ id }}>
      {({ loading, error, data }) => {
        if (error) return <Error error={error} />
        if (loading) return <LinearProgress color="secondary" />
        const response = data.asset
        return (
          <CtflAsset {...props} {...response} />
        )
      }}
    </Query>
  )
}

CtflAssetWithData.propTypes = {
  id: PropTypes.string.isRequired,
}
